<script lang="ts" setup>
import StatusMessage from "@/shared/components/StatusMessage/StatusMessage.vue";
import Button from "@/shared/components/Button/Button.vue";

defineProps<{
  title: string;
  text?: string;
  subText?: string;
}>();
</script>

<template>
  <div class="status-message-page">
    <slot name="icon"></slot>
    <div class="status-message-page--content">
      <StatusMessage :title="title">
        <template #text>
          <p v-if="text">{{ text }}</p>
          <p v-if="subText">{{ subText }}</p>
          <slot name="text"></slot>
        </template>
        <template #actions>
          <Button
            :caption="$t('shared.action.toLogin')"
            href="/login"
          />
        </template>
      </StatusMessage>
    </div>
  </div>
</template>

<style scoped>
@import "StatusMessagePage.css";
</style>
